import { createRouter, Navigate } from '@tanstack/react-router';

import { MainErrorBoundary } from './_components/error/errors-modern';
import { routeTree } from './routeTree.gen';

export const router = createRouter({
  routeTree,
  defaultPendingComponent: () => (
    <div className="ldr">
      <img src="/loader.png" height="144" width="144" alt="Achieve Test Prep Portal" />
    </div>
  ),
  defaultErrorComponent: MainErrorBoundary,
  defaultNotFoundComponent: () => <Navigate to="/" />,
  scrollRestoration: true,

  defaultPreload: 'intent',
  defaultPreloadDelay: 300,
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
